import { store } from '@/redux/lib/configureStore';
import getLogTimeMachine from '../../workflowLogs/lib/getLogTimeMachine';
import selectors from '@/redux/selectors/selectors';

const getTimeMachineEntry = ({ logId, operationLog }) => {
  const state = store.getState();
  const output = selectors.workflowLogOutputById(state, logId);
  const operationLogs = selectors.workflowOperationLogsByLogId(state, logId);
  const activeLog = selectors.workflowLogsById(state, logId);
  const triggerStep = activeLog?.meta?.triggerStep;

  const { timeMachine } = getLogTimeMachine({ output, operationLogs, time: 0, triggerStep });

  const matchingEntry = timeMachine?.find((entry) => entry.step?.stepInstanceId === operationLog?.stepInstanceId);

  if (!matchingEntry) {
    return null;
  }

  return {
    index: matchingEntry.index
  };
};

export default getTimeMachineEntry;
